export function ChevronUpCustomIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.76569 5.16578C7.45327 5.4782 6.94673 5.4782 6.63431 5.16578L4 2.53147L1.36569 5.16578C1.05327 5.4782 0.546734 5.4782 0.234315 5.16578C-0.078105 4.85336 -0.078105 4.34683 0.234315 4.03441L3.43431 0.834412C3.74673 0.521993 4.25327 0.521993 4.56569 0.834412L7.76569 4.03441C8.07811 4.34683 8.0781 4.85336 7.76569 5.16578Z'
        fill='currentColor'
      />
    </svg>
  )
}
